// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__iWZXV","footerContent":"Footer_footerContent__HzZZ+","socialIcons":"Footer_socialIcons__BSyDD","icon":"Footer_icon__QK1Yu","links":"Footer_links__CpHUJ"};